import { Injectable } from '@angular/core';
import { createAction, props, Store } from '@ngrx/store';
import { WorkflowModelInfos } from '../../../models/workflow/workflowModelInfos';

export class WorkflowModelInfosConstantAction {
  static readonly LOAD_MODEL_INFOS_PROCESS_START = '[WorkflowModelInfos].LOAD_LABELS_PROCESS_START';
  static readonly LOAD_MODEL_INFOS_PROCESS_SUCCEED = '[WorkflowModelInfos].LOAD_LABELS_PROCESS_SUCCEED';
  static readonly LOAD_MODEL_INFOS_PROCESS_FAILED = '[WorkflowModelInfos].LOAD_LABELS_PROCESS_FAILED';

  static readonly LOAD_MODEL_INFOS_TASK_START = '[WorkflowModelInfos].LOAD_LABELS_TASK_START';
  static readonly LOAD_MODEL_INFOS_TASK_SUCCEED = '[WorkflowModelInfos].LOAD_LABELS_TASK_SUCCEED';
  static readonly LOAD_MODEL_INFOS_TASK_FAILED = '[WorkflowModelInfos].LOAD_LABELS_TASK_FAILED';
}

export const createActionLoadWorkflowModelInfosProcessStartAction = createAction(WorkflowModelInfosConstantAction.LOAD_MODEL_INFOS_PROCESS_START);
export const createActionLoadWorkflowModelInfosProcessSucceededAction= createAction(WorkflowModelInfosConstantAction.LOAD_MODEL_INFOS_PROCESS_SUCCEED, props<{payload: WorkflowModelInfos[]}>() );
export const createActionLoadWorkflowModelInfosProcessFailedAction = createAction(WorkflowModelInfosConstantAction.LOAD_MODEL_INFOS_PROCESS_FAILED , props<{error: Error}>());


export const createActionLoadWorkflowModelInfosTaskStartAction = createAction(WorkflowModelInfosConstantAction.LOAD_MODEL_INFOS_TASK_START);
export const createActionLoadWorkflowModelInfosTaskSucceededAction= createAction(WorkflowModelInfosConstantAction.LOAD_MODEL_INFOS_TASK_SUCCEED, props<{payload: WorkflowModelInfos[]}>() );
export const createActionLoadWorkflowModelInfosTaskFailedAction = createAction(WorkflowModelInfosConstantAction.LOAD_MODEL_INFOS_TASK_FAILED , props<{error: Error}>());

  @Injectable({
  providedIn: 'root'
})
export class WorkflowModelInfosAction {

  constructor( private localStore: Store ) {
  }

    public loadWorkflowModelInfosProcessStarted(): void {
      this.localStore.dispatch( createActionLoadWorkflowModelInfosProcessStartAction() );
    }

    public loadWorkflowModelInfosProcessSucceeded( payload: WorkflowModelInfos[] ): void {
      this.localStore.dispatch( createActionLoadWorkflowModelInfosProcessSucceededAction( { payload } ) );
    }

    public loadWorkflowModelInfosProcessFailed( error: any ) {
      this.localStore.dispatch( createActionLoadWorkflowModelInfosProcessFailedAction( { error } ) );
    }

  public loadWorkflowModelInfosTaskStarted(): void {
    this.localStore.dispatch( createActionLoadWorkflowModelInfosTaskStartAction() );
  }

  public loadWorkflowModelInfosTaskSucceeded( payload: WorkflowModelInfos[] ): void {
    this.localStore.dispatch( createActionLoadWorkflowModelInfosTaskSucceededAction( { payload } ) );
  }

  public loadWorkflowModelInfosTaskFailed( error: any ) {
    this.localStore.dispatch( createActionLoadWorkflowModelInfosTaskFailedAction( { error } ) );
  }
}
